import VueRouter from 'vue-router'
// import { checkMobile } from '@/core/utils'
// wclient
import Web from '@/Web'

import Login from '@/views/login/Login.vue'

// order
import OrderHome from '@/views/order/index'
import OrderPage from '@/views/order/OrderPage'
import OrderUnloadingPage from '@/views/order/UnloadingOrderPage.vue'
import OrderCreate from '@/views/order/OrderCreate'
import OrderDetail from '@/views/order/OrderDetail'
import DoPage from '@/views/order/DoPage'
// import TempPage from '@/views/order/temp'

// // jobs
import JobHome from '@/views/jobs/index'
import JobCreate from '@/views/jobs/JobCreate.vue'
import JobModify from '@/views/jobs/JobModify.vue'
import JobPage from '@/views/jobs/JobPage.vue'
import JobDetail from '@/views/jobs/JobDetail'
import JobInstruction from '@/views/jobs/JobInstruction'
// import GroupLables from '@/views/jobs/GroupLables'

// pallet
import PalletHome from '@/views/pallet/index'
import PalletPage from '@/views/pallet/PalletPage'
import PalletDetail from '@/views/pallet/PalletDetail'
import PalletLabelPage from '@/views/pallet/PalletLabelPage'
import PalletSplitPage from '@/views/jobs/PalletSplit.vue'

// stack
import WarehouseHome from '@/views/warehouse/index'
import SlotPage from '@/views/warehouse/SlotPage'
import StackHome from '@/views/warehouse/StackHome'
import StackPage from '@/views/warehouse/StackPage'
import StackLabelsPage from '@/views/warehouse/StackLabelsPage'

// shipment
import ShipmentHome from '@/views/shipment/index'
import StockPage from '@/views/shipment/StockPage'
import ShipmentPage from '@/views/shipment/ShipmentPage'
import ShipmentTrucks from '@/views/shipment/ShipmentPickUpPage.vue'
import ShipmentDetail from '@/views/shipment/ShipmentDetail'
import BolPage from '@/views/shipment/BolPage'
import ShipmentCreate from '@/views/shipment/ShipmentCreate'

// address
import AddressPage from '@/views/address/AddressPage'
import AddressDetail from '@/views/address/AddressDetail'

// container
import ContainerSearch from '@/views/container/ContainerSearch'
import PDAPage from '@/views/pda/PDAPage'
import LabelCraft from '@/views/tools/LabelCraft.vue'

// admin
import AdminHome from '@/views/admin/index'
import ResourceView from '@/views/admin/Resource.vue'
import RoleView from '@/views/admin/Role.vue'
import UserPage from '@/views/admin/User.vue'

// user info
import UserInfo from '@/views/user/index.vue'
import { getToken } from '@/core/utils/token'
import { getUserInfoFromToken } from '@/api/user'
// import { ResponseSuccess } from '@/core/utils/codes'

// import ReactWrapper from '@/views/react/Wrapper.vue'
import IntegrationOrders from '@/views/react/b2b/IntegrationOrders.vue'
import ScanOrderCreatePage from '@/views/react/b2b/CreateScanOrder.vue'
import ProcessScanOrderPage from '@/views/react/b2b/ProcessScanOrder.vue'
import InstaWorksheet from '@/views/react/b2b/InstaWorksheet.vue'
import store from '@/store'

export const Group = 'group'
export const Item = 'item'
export const ItemInvisible = 'item invisible'

// DetailRoutes
const WebRoutes = {
  order: {
    type: Group,
    label: 'Orders',
    iconName: 'order',
    pathIndex: '/order',
    defaultIndex: 0,
    meta: { name: 'Order' },
    component: OrderHome,
    visible: true,
    children: [
      {
        type: Item,
        pathIndex: 'list',
        label: 'All Orders',
        iconName: '',
        meta: { name: 'All' },
        visible: true,
        component: OrderPage,
        name: 'OrderPage'
      },
      {
        type: Item,
        pathIndex: 'unloading',
        label: 'Unloading',
        iconName: '',
        meta: { name: 'Unloading' },
        visible: true,
        component: OrderUnloadingPage
      },
      {
        type: Item,
        pathIndex: 'b2b',
        label: 'Integration',
        iconName: '',
        meta: { name: 'B2B' },
        visible: true,
        component: IntegrationOrders
      },
      {
        type: Item,
        pathIndex: 'insta',
        label: 'Insta 360',
        iconName: '',
        meta: { name: 'Insta' },
        visible: true,
        component: InstaWorksheet
      },
      {
        type: Item,
        pathIndex: 'scan_create',
        meta: { name: 'Scan Create' },
        label: 'New Scan Order',
        visible: false,
        iconName: '',
        component: ScanOrderCreatePage
      },
      {
        type: Item,
        pathIndex: 'scan_process',
        meta: { name: 'Scan Process' },
        label: 'Process Scan Order',
        visible: false,
        iconName: '',
        component: ProcessScanOrderPage
      },
      {
        type: Item,
        pathIndex: 'create',
        meta: { name: 'Create' },
        label: 'New Order',
        visible: false,
        iconName: '',
        component: OrderCreate
      },
      {
        type: Item,
        pathIndex: ':no',
        label: 'Order Detail',
        meta: { name: 'Detail' },
        visible: false,
        iconName: '',
        component: OrderDetail
      },
      {
        type: Item,
        pathIndex: 'do/:no',
        label: 'DO',
        iconName: '',
        meta: { name: 'DO' },
        visible: false,
        component: DoPage
      }
    ]
  },
  stock: {
    type: Group,
    label: 'Warehouse',
    iconName: 'stock',
    pathIndex: '/warehouse',
    defaultIndex: 0,
    component: WarehouseHome,
    meta: { name: 'Warehouse' },
    visible: true,
    children: [
      {
        type: Group,
        label: 'Pallets',
        iconName: 'stock',
        pathIndex: 'pallet',
        meta: { name: 'Pallets' },
        defaultIndex: 0,
        component: PalletHome,
        visible: true,
        children: [
          {
            type: Item,
            pathIndex: '',
            label: 'All Pallets',
            meta: { name: 'All' },
            visible: true,
            iconName: '',
            component: PalletPage
          },
          {
            type: Item,
            pathIndex: ':no',
            label: 'PalletDetail',
            meta: { name: 'Detail' },
            visible: false,
            iconName: '',
            component: PalletDetail
          },
          {
            type: Item,
            pathIndex: 'label/:no',
            label: 'PalletLabelPage',
            iconName: '',
            meta: { name: 'Label' },
            visible: false,
            component: PalletLabelPage
          }
        ]
      },
      {
        type: Item,
        label: 'Slots',
        pathIndex: 'slot',
        component: SlotPage,
        meta: { name: 'Slots' },
        visible: false
      },
      {
        type: Group,
        label: 'Stacks',
        pathIndex: 'stack',
        component: StackHome,
        meta: { name: 'Stacks' },
        defaultIndex: 0,
        visible: true,
        children: [
          {
            type: Item,
            pathIndex: '',
            label: 'All Stacks',
            meta: { name: 'All' },
            visible: true,
            iconName: '',
            component: StackPage
          },
          {
            type: Item,
            pathIndex: 'labels/:no',
            label: 'Labels',
            iconName: '',
            meta: { name: 'Labels' },
            visible: false,
            component: StackLabelsPage
          }
        ]
      }
    ]
  },
  shipment: {
    type: Group,
    label: 'Shipments',
    iconName: 'shipment',
    pathIndex: '/shipment',
    defaultIndex: 0,
    component: ShipmentHome,
    meta: { name: 'Shipment' },
    visible: true,
    children: [
      {
        type: Item,
        label: 'Stock',
        pathIndex: 'stock',
        component: StockPage,
        meta: { name: 'Stock' },
        name: 'StockPage',
        visible: true
      },
      {
        type: Item,
        pathIndex: 'all',
        label: 'All Ships',
        meta: { name: 'All' },
        visible: true,
        component: ShipmentPage
      },
      {
        type: Item,
        pathIndex: 'trucks',
        label: 'Ship Trucks',
        meta: { name: 'Trucks' },
        visible: true,
        component: ShipmentTrucks
      },
      {
        type: Item,
        pathIndex: 'create',
        label: 'Shipment Create',
        meta: { name: 'Create' },
        visible: false,
        component: ShipmentCreate,
        name: 'ShipmentCreate'
      },
      {
        type: Item,
        pathIndex: ':no',
        label: 'ShipmentDetail',
        meta: { name: 'Detail' },
        visible: false,
        component: ShipmentDetail
      },
      {
        type: Item,
        pathIndex: 'bol/:no',
        label: 'BOL',
        iconName: '',
        meta: { name: 'BOL' },
        visible: false,
        component: BolPage
      }
    ]
  },
  jobs: {
    type: Group,
    label: 'Jobs',
    iconName: 'jobs',
    meta: { name: 'Jobs' },
    pathIndex: '/jobs',
    defaultIndex: 0,
    component: JobHome,
    visible: true,
    children: [
      {
        type: Item,
        pathIndex: 'list',
        label: 'All Jobs',
        meta: { name: 'Search' },
        visible: true,
        iconName: '',
        component: JobPage,
        name: 'JobPage'
      },
      {
        type: Item,
        pathIndex: 'create',
        label: 'Create',
        meta: { name: 'Create' },
        visible: false,
        iconName: '',
        component: JobCreate,
        name: 'JobCreate'
      },
      {
        type: Item,
        pathIndex: 'modify',
        label: 'Modify',
        meta: { name: 'Modify' },
        visible: false,
        iconName: '',
        component: JobModify,
        name: 'JobModify'
      },
      {
        type: Item,
        pathIndex: 'split',
        label: 'PalletSplitPage',
        iconName: '',
        meta: { name: 'Split Job' },
        visible: false,
        component: PalletSplitPage
      },
      {
        type: Item,
        pathIndex: ':no',
        label: 'Detail',
        meta: { name: 'Detail' },
        visible: false,
        iconName: '',
        component: JobDetail,
        name: 'JobDetail'
      },
      {
        type: Item,
        pathIndex: 'instruction/:no',
        label: 'Instruction',
        iconName: '',
        meta: { name: 'Instruction' },
        visible: false,
        component: JobInstruction
      }
    ]
  },
  containers: {
    type: Group,
    label: 'Tools',
    iconName: 'jobs',
    meta: { name: 'Tools' },
    pathIndex: '/tool',
    defaultIndex: 0,
    component: JobHome,
    visible: true,
    children: [
      {
        type: Item,
        pathIndex: 'container',
        label: 'Container',
        meta: { name: 'Container' },
        visible: true,
        iconName: '',
        component: ContainerSearch,
        name: 'ContainerSearch'
      },
      {
        type: Item,
        pathIndex: 'address',
        label: 'Address',
        meta: { name: 'Address' },
        visible: true,
        component: AddressPage
      },
      {
        type: Item,
        pathIndex: 'labels',
        label: 'Labels',
        meta: { name: 'Labels' },
        visible: true,
        component: LabelCraft
      },
      {
        type: Item,
        pathIndex: 'address/:id',
        label: 'Address',
        meta: { name: 'Address' },
        visible: false,
        component: AddressDetail,
        name: 'AddressDetail'
      }
    ]
  },
  admin: {
    type: Group,
    label: 'Admin',
    iconName: 'admin',
    pathIndex: '/admin',
    defaultIndex: 0,
    component: AdminHome,
    meta: { name: 'Admin' },
    visible: true,
    children: [
      {
        type: Item,
        pathIndex: 'resource',
        label: 'Resource',
        visible: true,
        iconName: '',
        component: ResourceView,
        meta: { name: 'Resource' }
      },
      {
        type: Item,
        pathIndex: 'role',
        label: 'Role',
        visible: true,
        iconName: '',
        component: RoleView,
        meta: { name: 'Role' }
      },
      {
        type: Item,
        pathIndex: 'user',
        label: 'User',
        visible: true,
        iconName: 'user',
        component: UserPage,
        meta: { name: 'User' }
      }
    ]
  },
  settings: {
    type: Item,
    label: 'Settings',
    iconName: 'settings',
    pathIndex: '/settings',
    meta: { name: 'Settings' },
    visible: false
  },
  user: {
    type: Item,
    label: 'UserInfo',
    iconName: 'user',
    pathIndex: '/user',
    meta: { name: 'User Info' },
    component: UserInfo,
    visible: false
  }
}

function getRoute(route) {
  let routeConfig = {}
  if (route.type === Group) {
    routeConfig = {
      path: route.pathIndex,
      children: route.children.map(getRoute),
      component: route.component,
      redirect: '',
      meta: route.meta
    }
    routeConfig.redirect =
      routeConfig.path + '/' + routeConfig.children[route.defaultIndex].path
  } else if (route.type === Item) {
    routeConfig = {
      path: route.pathIndex,
      name: route.name,
      component: route.component,
      props: true,
      meta: route.meta
    }
  }
  return routeConfig
}

const webRoutes = Object.values(WebRoutes).map(getRoute)

function getNavbarConfig(route) {
  let menuItem
  if (route.type === Group) {
    menuItem = {
      type: route.type,
      index: route.pathIndex,
      text: route.label,
      icon: route.iconName,
      subs: route.children
        .filter(child => child.visible)
        .map(child => getNavbarConfig(child))
    }
  } else if (route.type === Item) {
    menuItem = {
      type: route.type,
      icon: route.iconName,
      index: route.pathIndex,
      text: route.label
    }
  }
  return menuItem
}

const BaseRoutes = [
  {
    path: '/pda',
    component: PDAPage
  },
  {
    path: '/',
    redirect: '/order',
    component: Web,
    children: webRoutes,
    beforeEnter: (to, from, next) => {
      const token = getToken()
      getUserInfoFromToken(token)
        .then(res => {
          store.commit('setUser', res)
          next()
        })
        .catch(_ => {
          store.commit('setUser', null)
          next('/login')
        })
    }
  },
  {
    path: '/login',
    component: Login,
    beforeEnter: (to, from, next) => {
      const token = getToken()
      if (token) {
        getUserInfoFromToken(token)
          .then(res => {
            store.commit('setUser', res)
            next('/')
          })
          .catch(_ => {
            store.commit('setUser', null)
            next()
          })
      } else {
        next()
      }
    }
  }
]

export const NavbarConfigs = Object.values(WebRoutes)
  .filter(route => route.visible)
  .map(route => getNavbarConfig(route))

const router = new VueRouter({
  mode: 'history',
  routes: BaseRoutes // short for `routes: routes`
})

// router.beforeEach((to, from, next) => {
// first check web browser, mobile or pc
// const isMobile = checkMobile()
// const path = to.path
// if (isMobile) {
//   // mobile
//   if (!path.startsWith('/mobile')) {
//     next({ ...to, path: '/mobile' + to.path })
//   }
//   if (to.matched.length === 0) {
//     next({ path: '/mobile/' })
//   }
// } else {
//   // normal website
//   if (path.startsWith('/mobile')) {
//     next({ path: '/order' })
//   }
// }
//   next()
// })

// open new window with command/ctrl click
router.beforeEach((to, from, next) => {
  const isCtrlKey =
    window.event && (window.event.ctrlKey || window.event.metaKey)

  if (isCtrlKey) {
    window.open(to.path, '_blank')
  } else {
    next()
  }
})

export default router
